define(
  'app/views/location_categories_list_view',['app/setup'],
  function(takhfifan) {

  takhfifan.LocationCategoriesListView = takhfifan.BaseView.extend({

    events: {
      'click .category-link' : 'toggleCategory'
    },

    initialize: function(options) {
      var _this = this;
      takhfifan.eventHub.on('location:categoryChanged', function(catId) {
        _this.toggleCategoryById(catId);
      });
    },

    toggleCategory: function(event) {
      var $target = $(event.target).closest("li");
      if ($target.hasClass('disable')) {
        event.preventDefault();
      }
      if($target.hasClass('active')){
        event.preventDefault();
        takhfifan.locationPageRouter.navigate('#/', {trigger: true});
      }
    },

    toggleCategoryByEl: function($target){
      if (!($target.hasClass('active'))) {
        this.$el.find('li.active').each(function() {
          $(this).removeClass('active');
          takhfifan.eventHub.trigger('location:hideCategory',
            {categoryId:$(this).attr('data-categoryId')});
        });

        $target.addClass('active');
        this.$el.find('li').removeClass('white-background');
        takhfifan.eventHub.trigger('location:showCategory',
          {categoryId:$target.attr('data-categoryId')});
      } else {
        $target.removeClass('active');
        this.showAllCategories();
      }
    },

    toggleCategoryById: function(catId){
      var $target=this.$el.find('li[data-categoryId=' + catId + ']');
      if(!$target.length){
        this.showAllCategories();
      }else{
        this.toggleCategoryByEl($target);
      }
    },

    showAllCategories: function() {
      this.$el.find('li').each(function() {
        $(this).removeClass('active');
      });
      this.$el.find('li[data-categoryId=-1]').addClass('active');

      takhfifan.eventHub.trigger('location:showCategory',
        {categoryId:"-1"}); //to show ALL deals in the district
      this.$el.find('li').addClass('white-background');
    }

  });
});
